import React from 'react';
import { Card } from 'antd';
import { cardHeaderStyle } from "./util/Style";
import Premise from "./Premise";

const aboutStyle = {
    marginBottom: 5,
};


function About() {

    return (
        <>
            <Premise />
            <Card headStyle={cardHeaderStyle} style={aboutStyle} title="Nu-Med Labs Master Data Management">
                <p>Version 0.1</p>
                <p>Feb-2022</p>
            </Card>
        </>
    )
}

export default About;